import React from 'react';
import { Helmet } from 'react-helmet-async';

import useEncounter from 'hooks/useEncounter';

export default function InteractiveStories() {
  const { encounters, isLoading } = useEncounter();

  return (
    <div>
      <Helmet>
        <title>Interactive Stories - DuskBreakers</title>
        <meta name="description" content="Interactive Story List" />
      </Helmet>
      <section>
        <div className="container">
          <div className="row">
            <div className="col">
              <h1 className="mb-5">Stories {encounters.length}</h1>
            </div>
          </div>
        </div>
        {!isLoading &&
          encounters.map((encounter) => {
            const { id, title } = encounter;
            return (
              <div key={id}>
                <a href={'/interactive-stories/' + id}>{title}</a>
              </div>
            );
          })}
      </section>
    </div>
  );
}
